import { DID_CLASS } from 'voxloud-types/dist/models';
import { Address } from './address.model';

export enum CONTROL_PANEL_ENVIRONMENT {PRODUCTION, STAGING};

export interface CompanyDidNumber {
  label: string | null;
  number: string,
  class: DID_CLASS
}

export class Company {
  companyId: number;
  name: string;
  alphaname: string;
  email: string;
  didNumbers: CompanyDidNumber[];
  locked: boolean;
  address: Address;
  pbxId: number;
  chargebeeId: string;
  password: string;
  username: string;
  faxBoxes: string[];
  billingId: number;
  hasFax: boolean;
  balance: number;
  hasDocuments: boolean;
  hasRecordings: boolean;
  kazooId: string;
  taxId: string;
  readOnly: boolean;
  // UI-related optional props
  locking?: boolean;
  unlocking?: boolean;
  deleting?: boolean;
}

export interface HubspotData {
    id: number,
    deal_id: number,
    deal_owner_id: number,
    deal_owner_name: string
}

export interface UpdateCustomerCompanyRequest {
  company_id: number;
  company_name: string;
  company_language: string;
  billing_country: string;
  hubspot_deal_id: number;
  notes_administration: string;
  notes_support: string;
  notes_success: string;
  notes_sales: string;
}

export interface CompanyFilters {
  name?: string;
  id?: string;
  alphaname?: string;
  email?: string;
  did?: string;
  billingId?: string;
}

export interface AdditionalCompanyData {
  billing_country: string;
  id: number;
  intercom_id: string;
  language: string;
  notes_administration: string;
  notes_sales: string;
  notes_success: string;
  notes_support: string;
  paymentMethodType: string;
  hubspot_data?: HubspotData;
  business_category: {
    business_category_translations: BusinessCategoryType[];
    id: number;
  };
  business_type?: {
    translations: BusinessCategoryType[];
    id: number;
  };
  other_business_type?: string;
}

export interface BusinessCategoryType {
  id: number;
  name: string;
  language?: string;
}

export enum NOTE_TYPES {
  administration = 'administration',
  sales = 'sales',
  success = 'success',
  support = 'support',
}

export interface NotesModel {
  notes_administration: string;
  notes_sales: string;
  notes_success: string;
  notes_support: string;
}

export interface KazooInstance {
	id: string;
	name: string;
	default_queue_module: string,
	available_queue_modules: string[]
}

export interface KazooMetadata {
	default_kazoo_instance_id: string;
	kazoo_instances: KazooInstance[]
}

export interface ContactsConfiguration {
  id: number,
  company_id: number,
  storage: string,
  include_users: boolean
}

export interface CompanyChatInfo {
  id: string;
  name: string;
  email_id: string | null;
}